/** returns Transfers Requests Received List
@return { Array }
*/
export const getRequestsReceivedList = state => {
    return state.transfersRequestsReceivedList
}

/** returns Transfers Requests Status List
@return { Array }
*/
export const getRequestsStatusList = state => {
    return state.transfersRequestsStatusList
}

/** returns Account Movements hasMore value
@return { Boolean }
*/
export const getReceivedRequestsHasMore = state => state.transfersRequestsReceivedHasMore
